angular.module('NumbersEditor')
    .factory('GameFactory', [
        '$http', 'EventFactory', function($http, eventFactory) {

            var urlBase = '/api/Game';
            var gameFactory = {};

            gameFactory.getGame = function (id, sportCode, startDate) {
                return $http.get(urlBase + '/' + id + "?sportCode=" + sportCode + "&startDate=" + encodeURIComponent(startDate));
            };

            gameFactory.insertGame = function(game) {
                return $http.post(urlBase, game);
            };

            gameFactory.saveGame = function (game) {
                return $http.post(urlBase + '/' + game.id + '/save', game);
            };

            gameFactory.deleteGame = function(id) {
                return $http.delete(urlBase + '/' + id);
            };

            gameFactory.DeleteGame = function (id) {
                return $http.delete(urlBase + '/' + id);
            }

            gameFactory.CancelGame = function(id) {
                return $http.post(urlBase + '/' + id + '/cancel');
            };

            gameFactory.VoidGame = function(id) {
                return $http.post(urlBase + '/' + id + '/void');
            };

            gameFactory.UnCancelGame = function(id) {
                return $http.post(urlBase + '/' + id + '/uncancel');
            };

            gameFactory.newGame = function(sportCode, startDate) {
                var events;

                if (sportCode == "49")
                    events = eventFactory.FortynineDefaultEvents();
                else
                    events = eventFactory.IrishLotteryDefaultEvents();

                var game =
                {
                    StartDate: startDate,
                    SportCode: sportCode,
                    Events: events
                };
                return game;
            };

            gameFactory.TwoDrawApprovedButtons = function () {
                return $http.get(urlBase + "/TwoDrawApprovedButtons");
            };

            gameFactory.GetdrawApprovalDetails = function (id) {
                return $http.get(urlBase + '/' + id + '/GetdrawApprovalDetails');
            };

            gameFactory.SiSTechApprove = function (id) {
                return $http.post(urlBase + '/' + id + '/SiSTechApprove');
            };

            gameFactory.AdjudicatorApprove = function (id) {
                return $http.post(urlBase + '/' + id + '/AdjudicatorApprove');
            };
            
            gameFactory.PublishResult = function (id) {
                return $http.post(urlBase + '/' + id + '/publishresult');
            };
            return gameFactory;
        }
    ]);